import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import MetadataWrapper from 'components/metadata-wrapper'
import WidgetMaker from 'components/widget-maker'
import CopyToClipboard from 'components/copy-to-clipboard'

import styles from './event-group-integrations-page.css'

export class EventGroupIntegrationsPage extends Component {
  render() {
    const { eventGroup, partner } = this.props

    if (!(eventGroup && partner)) {
      return null
    }

    return (
      <div styleName="page">
        <RelayoutWrapper>
          <Relayout align="center">
            <RelayoutItem xl="10">

              <h2 styleName="title">Whitelabel URL</h2>
              <MetadataWrapper label="Whitelabel URL">
                <CopyToClipboard link={eventGroup.whitelabelUrl} />
              </MetadataWrapper>

              <h2 styleName="title">Widget</h2>
              <WidgetMaker whitelabelUrl={eventGroup.whitelabelUrl} linkSlug={partner.linkSlug} />
            </RelayoutItem>
          </Relayout>
        </RelayoutWrapper>
      </div>
    )
  }
}

EventGroupIntegrationsPage.propTypes = {
  eventGroup: PropTypes.object,
  partner: PropTypes.object,
}

export default CSSModules(EventGroupIntegrationsPage, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/event-group-integrations-page/event-group-integrations-page.js
 **/